export enum FeedbackType {
  COMMENT = 'COMMENT',
  PROBLEM = 'PROBLEM',
  SUGGESTION = 'SUGGESTION',
  OTHER = 'OTHER',
}



export type Feedback = {
  feedbackId: string;
  userId: string;
  rating?: number;
  comment?: string;
  type: FeedbackType;
  metadata?: any;
  createdAt?: Date;
  updatedAt?: Date;
  user?: {
    userId: string;
    firstName?: string;
    lastName?: string;
    email: string;
  };
};

export interface CreateFeedbackInput {
  rating?: number;
  comment?: string;
  type: FeedbackType;
  metadata?: any;
  userId: string;
}

export interface createFeedbackRequest {
  createFeedback: Feedback;
}

export interface getAllFeedbackRequest {
  getAllFeedback: Feedback[];
}

export interface FeedbackPaginationCriteria {
  page: number;
  limit: number;
  search?: string;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
}

export interface getPaginatedFeedbackRequest {
  getPaginatedFeedback: {
    feedbacks: Feedback[];
    count: number;
  };
}
